import type { TrainingProgram } from '../types'

export function localDateKey(date = new Date()) {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')
  return `${year}-${month}-${day}`
}

export function displayDate(date = new Date()) {
  const text = new Intl.DateTimeFormat('ru-RU', { weekday: 'long', day: 'numeric', month: 'long' }).format(date)
  return text.charAt(0).toUpperCase() + text.slice(1)
}

export function programDay(program: TrainingProgram, date = new Date()) {
  const start = new Date(`${program.startDate}T12:00:00`)
  const current = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 12)
  const diff = Math.floor((current.getTime() - start.getTime()) / 86_400_000) + 1
  return Math.min(program.durationDays, Math.max(1, diff))
}

export function formatDuration(seconds: number) {
  const min = Math.floor(seconds / 60)
  const sec = seconds % 60
  return `${String(min).padStart(2, '0')}:${String(sec).padStart(2, '0')}`
}
